import React from "react"

import { ProductPositionFormTabType } from "features/product-position-management/types/ProductPositionFormTabType"

import { EditProductPositionOverlayView } from "./EditProductPositionOverlayView"
import { useEditProductPositionOverlayModel } from "./hooks/useEditProductPositionOverlayModel"

export interface EditProductPositionOverlayPayload {
  projectID: string
  productPositionID: string
  defaultTab?: ProductPositionFormTabType
}

export interface EditProductPositionOverlayProps {
  payload: EditProductPositionOverlayPayload
}

export const EditProductPositionOverlay = React.memo(
  (props: EditProductPositionOverlayProps) => (
    <EditProductPositionOverlayView
      {...useEditProductPositionOverlayModel(props)}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    EDIT_PRODUCT_POSITION_OVERLAY: EditProductPositionOverlayPayload
  }
}
